const FuelType = {
    NOTSELECTED_FUELTYPE: 0,
    JAT_A_FUELTYPE: 1,
    HUNDRED_LL_FUELTYPE: 2,
}

export default FuelType;